document.addEventListener('DOMContentLoaded', function() {
const colorMap = {
  // Esistenti
  'ALTRO': '#CCCCCC',
  'ALTRI': '#CCCCCC',
  'ARANCIO': '#FFA500',
  'AZZURRO': '#5DADE2',
  'BEIGE': '#F5F5DC',
  'BIANCO': '#FFFFFF',
  'BLU': '#0000FF',
  'BORDEAUX': '#800000',
  'DENIM': '#1560BD',
  'FANGO': '#A09576',
  'FUCSIA': '#FF00FF',
  'GIALLO': '#FFFF00',
  'GRIGIO': '#808080',
  'MARRONE': '#A52A2A',
  'NERO': '#000000',
  'NUDE': '#F2D3C6',
  'PANNA': '#FFFDD0',
  'ROSA': '#FFC0CB',
  'ROSSO': '#FF0000',
  'VERDE': '#008000',
  'VIOLA': '#800080',
  'ARGENTO': '#C0C0C0',
  'ORO': '#FFD700',
  'LILLA': '#C8A2C8',
  'MULTICOLORE': 'linear-gradient(45deg, red, orange, yellow, green, blue, indigo, violet)',
  'MULTICOLOR': 'linear-gradient(45deg, red, orange, yellow, green, blue, indigo, violet)',

  // Aggiunti
  'ANIMALIER': 'repeating-linear-gradient(45deg, #8B4513, #8B4513 10px, #F5DEB3 10px, #F5DEB3 20px)', // effetto zebrato
  'CREMA': '#FFFDD0',
  'KAKI': '#C3B091',
  'METALLICO': 'linear-gradient(45deg, #C0C0C0, #E0E0E0, #A0A0A0)' // effetto metallico
};


  document.querySelectorAll('.catfiltercolor').forEach(label => {
    const text = label.querySelector('.facet-checkbox__text');
    if (!text) return;
    const colorName = text.textContent.trim().split(' (')[0].toUpperCase();
    const colorValue = colorMap[colorName];
    if (!colorValue) return;
    const input = label.querySelector('input[type="checkbox"]');
    if (!input) return;
    if (colorValue.startsWith('linear-gradient')) {
      input.style.background = colorValue;
    } else {
      input.style.backgroundColor = colorValue;
    }
  });
});
